import { del } from '#/utils/http/del';

export async function userDashboardApiDeleteSavedListing(
  id: string,
  type: string,
) {
  return del(`/data/saved-listings/${type}/${id}`);
}
